export type VehicleCondition = 'Usado' | '0KM'
export type Currency = 'USD' | 'ARS'
export type BodyType =
  | 'Sedán'
  | 'SUV'
  | 'Pick-up'
  | 'Hatchback'
  | 'Coupé'
export type Fuel = 'Nafta' | 'Diesel' | 'Híbrido' | 'GNC'
export type Transmission = 'Manual' | 'Automática'

export interface Vehicle {
  id: string
  slug: string
  marca: string
  modelo: string
  version: string
  anio: number
  kilometraje: number
  precio: number
  moneda: Currency
  tipo: BodyType
  estado: VehicleCondition
  combustible: Fuel
  transmision: Transmission
  color: string
  ubicacion: string
  descripcionCorta: string
  descripcionCompleta: string
  imagenPrincipal: string
  galeria: string[]
  disponible: boolean
  destacado: boolean
  oportunidad: boolean
  financiacion: boolean
  permuta: boolean
  whatsapp: string
  vendedor: string
  fechaPublicacion: string
}

export type SortKey = 'destacados' | 'recientes' | 'precio-asc' | 'precio-desc'

export interface VehicleFilters {
  q: string
  marca: string
  modelo: string
  anioDesde: string
  anioHasta: string
  precioMin: string
  precioMax: string
  kmMax: string
  tipo: string
  estado: string
  combustible: string
  transmision: string
  financiacion: boolean
  permuta: boolean
  oportunidad: boolean
  sort: SortKey
}

export const emptyFilters: VehicleFilters = {
  q: '',
  marca: '',
  modelo: '',
  anioDesde: '',
  anioHasta: '',
  precioMin: '',
  precioMax: '',
  kmMax: '',
  tipo: '',
  estado: '',
  combustible: '',
  transmision: '',
  financiacion: false,
  permuta: false,
  oportunidad: false,
  sort: 'destacados',
}
